import { motion } from 'framer-motion';
import React, { useState } from 'react';
import MagentaLine from '../elements/MagentaLine';
import Bg from '../../images/ui/dark-blue-bg.jpg';
import VideoBg from '../../video/moresound-intelligence-bg.mp4';
import MidPhase from '../../images/brainhearing-technology/mid-phase.png';

import HotSpot1 from '../../images/brainhearing-technology/intel-hotspot-1.png';
import HotSpot2 from '../../images/brainhearing-technology/intel-hotspot-2.png';
import HotSpot3 from '../../images/brainhearing-technology/intel-hotspot-3.png';
import HotSpot4 from '../../images/brainhearing-technology/intel-hotspot-4.png';
import HotSpot5 from '../../images/brainhearing-technology/intel-hotspot-5.png';
import HotSpot6 from '../../images/brainhearing-technology/intel-hotspot-6.png';
import HotSpotEasy from '../../images/brainhearing-technology/intel-easy-button.png';
import HotSpotDifficult from '../../images/brainhearing-technology/intel-difficult-button.png';
import CopyBlock1 from '../../images/brainhearing-technology/intel-copy-block-1.png';
import CopyBlock2 from '../../images/brainhearing-technology/intel-copy-block-2.png';

import BlockState0 from '../../images/brainhearing-technology/block-state-0.png';
import BlockState1 from '../../images/brainhearing-technology/block-state-1.png';
import BlockState2 from '../../images/brainhearing-technology/block-state-2.png';
import BlockState3 from '../../images/brainhearing-technology/block-state-3.png';
import BlockState4 from '../../images/brainhearing-technology/block-state-4.png';
import BlockState5 from '../../images/brainhearing-technology/block-state-5.png';
import BlockState6 from '../../images/brainhearing-technology/block-state-6.png';
import BlockStateEasy from '../../images/brainhearing-technology/block-state-easy.png';
import BlockStateDifficult from '../../images/brainhearing-technology/block-state-difficult.png';

import Popup1 from '../../images/brainhearing-technology/popup-1.png';
import Popup2 from '../../images/brainhearing-technology/popup-2.png';
import Popup3 from '../../images/brainhearing-technology/popup-3.png';
import Popup4 from '../../images/brainhearing-technology/popup-4.png';
import Popup5 from '../../images/brainhearing-technology/popup-5.png';
import Popup6 from '../../images/brainhearing-technology/popup-6.png';

import VideoButton from '../../images/brainhearing-technology/video-button.png';
import IntelligenceVideo from '../../video/moresound-intelligence.mp4';
import CloseButton from '../elements/CloseButton';

export default function MoreSoundIntelligence() {
  const [isVideoShowing, setIsVideoShowing] = useState(false);
  const handleVideoButton = () => {
    setIsVideoShowing(!isVideoShowing);
  };
  const [activeState, setActiveState] = useState(0);
  const [calloutState, setCalloutState] = useState(0);

  const getBlock = () => {
    // console.log(activeState);

    let state = 0;
    switch (activeState) {
      case 0:
        state = BlockState0;
        break;
      case 1:
        state = BlockState1;
        break;
      case 2:
        state = BlockState2;
        break;
      case 3:
        state = BlockState3;
        break;
      case 4:
        state = BlockState4;
        break;
      case 5:
        state = BlockState5;
        break;
      case 6:
        state = BlockState6;
        break;
      case 'easy':
        state = BlockStateEasy;
        break;
      case 'difficult':
        state = BlockStateDifficult;
        break;
      default:
        break;
    }
    return (
      <img
        src={state}
        alt=""
        id={`block-state-${activeState}`}
        className="block-state"
      />
    );
  };
  return (
    <div id="more-sound-intelligence" className="bh-tech-subpage">
      <img src={Bg} alt="" className="modal-full-bg" />
      <motion.video
        src={VideoBg}
        className="modal-full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="100px" left="19px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '28px',
              left: '18px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            MoreSound Intelligence™
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '22px',
              top: '72px',
              left: '18px',
              letterSpacing: '0.95px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            <strong>Precise analysis and balancing</strong> of the full sound
            scene
          </motion.div>
        </div>
      </header>

      <div className="heading">
        A quantum leap with three part signal processing.
      </div>

      <img src={MidPhase} alt="" id="mid-phase" className="hotspot" />

      {getBlock(activeState)}

      <img
        src={HotSpot1}
        alt=""
        id="hotspot-1"
        className="hotspot"
        onClick={() => {
          setActiveState(1);
          setCalloutState(1);
        }}
      />
      <img
        src={HotSpot2}
        alt=""
        id="hotspot-2"
        className={`hotspot ${activeState !== 0 ? 'active' : 'disable'}`}
        onClick={() => {
          setActiveState(2);
          setCalloutState(2);
        }}
      />
      <img
        src={HotSpot3}
        alt=""
        id="hotspot-3"
        className={`hotspot ${activeState !== 0 ? 'active' : 'disable'}`}
        onClick={() => {
          setActiveState(3);
          setCalloutState(3);
        }}
      />
      <img
        src={HotSpot4}
        alt=""
        id="hotspot-4"
        className={`hotspot ${
          activeState === 1 ||
          activeState === 2 ||
          activeState === 4 ||
          activeState === 'easy'
            ? 'active'
            : 'disable'
        }`}
        onClick={() => {
          setActiveState(4);
          setCalloutState(4);
        }}
      />
      <img
        src={HotSpot5}
        alt=""
        id="hotspot-5"
        className={`hotspot ${
          activeState === 1 ||
          activeState === 2 ||
          activeState === 5 ||
          activeState === 'difficult'
            ? 'active'
            : 'disable'
        }`}
        onClick={() => {
          setActiveState(5);
          setCalloutState(5);
        }}
      />
      <img
        src={HotSpot6}
        alt=""
        id="hotspot-6"
        className={`hotspot ${activeState === 6 ? 'active' : ''}`}
        onClick={() => {
          setActiveState(6);
          setCalloutState(6);
        }}
      />
      <img
        src={HotSpotEasy}
        alt=""
        id="hotspot-easy"
        className={`hotspot ${activeState === 'easy' ? 'active' : ''}`}
        onClick={() => {
          setActiveState('easy');
          setCalloutState(0);
        }}
      />
      <img
        src={HotSpotDifficult}
        alt=""
        id="hotspot-difficult"
        className={`hotspot ${activeState === 'difficult' ? 'active' : ''}`}
        onClick={() => {
          setActiveState('difficult');
          setCalloutState(0);
        }}
      />
      <img
        src={CopyBlock1}
        alt=""
        id="copy-block-1"
        className={`copy-block ${
          activeState === 1 || activeState === 3 || activeState === 'easy'
            ? 'active'
            : 'disable'
        }`}
      />
      <img
        src={CopyBlock2}
        alt=""
        id="copy-block-2"
        className={`copy-block ${
          activeState === 1 || activeState === 3 || activeState === 'difficult'
            ? 'active'
            : 'disable'
        }`}
      />

      {/* Popups */}
      <div
        id="popup-1"
        className={`popup ${calloutState === 1 ? 'active' : 'disable'}`}
      >
        <img src={Popup1} alt="" className="callout" />
        <CloseButton close={() => setCalloutState(0)} />
      </div>
      <div
        id="popup-2"
        className={`popup ${calloutState === 2 ? 'active' : 'disable'}`}
      >
        <img src={Popup2} alt="" className="callout" />
        <CloseButton close={() => setCalloutState(0)} />
      </div>
      <div
        id="popup-3"
        className={`popup ${calloutState === 3 ? 'active' : 'disable'}`}
      >
        <img src={Popup3} alt="" className="callout" />
        <CloseButton close={() => setCalloutState(0)} />
      </div>
      <div
        id="popup-4"
        className={`popup ${calloutState === 4 ? 'active' : 'disable'}`}
      >
        <img src={Popup4} alt="" className="callout" />
        <CloseButton close={() => setCalloutState(0)} />
      </div>
      <div
        id="popup-5"
        className={`popup ${calloutState === 5 ? 'active' : 'disable'}`}
      >
        <img src={Popup5} alt="" className="callout" />
        <CloseButton close={() => setCalloutState(0)} />
      </div>
      <div
        id="popup-6"
        className={`popup ${calloutState === 6 ? 'active' : 'disable'}`}
      >
        <img src={Popup6} alt="" className="callout" />
        <CloseButton close={() => setCalloutState(0)} />
      </div>

      <div id="video-button" onClick={handleVideoButton}>
        <img src={VideoButton} alt="" />
      </div>

      {isVideoShowing && (
        <div id="video-wrapper">
          <CloseButton close={handleVideoButton} id="video-close-button" />
          <video
            width="950"
            height="auto"
            id="moresound-intelligence-video"
            autoPlay
            onClick={function (evt) {
              const video = evt.target;
              video.setAttribute('controls', 'controls');
            }}
          >
            <source src={IntelligenceVideo} type="video/mp4" />
          </video>
        </div>
      )}
    </div>
  );
}
